import React from "react";
import { Link } from "react-router-dom";
import {
  BUY_ONLINE_ROUTE,
  HOME_ROUTE,
  SELL_ONLINE_ROUTE,
} from "../../../routes/constant";

import { MdHome, MdSell, MdShoppingBag } from "react-icons/md";

const RectangleGridButtons = ({ isDarkMode }) => {
   const buttons = [
    {
      id: "home",
      label: "Home",
      icon: MdHome, 
      ROUTE: HOME_ROUTE,
    },
    {
      id: "sell",
      label: "Sell",
      icon: MdSell,
      ROUTE: SELL_ONLINE_ROUTE,
    },
    {
      id: "buy",
      label: "Buy",
      icon: MdShoppingBag,
      ROUTE: BUY_ONLINE_ROUTE,
    },
  ];

  return (
    <div className="w-full">
      {/* Mobile: Compact green tabs with dot separators - hidden on desktop */}
      <div className="w-full md:hidden">
        <div className="flex items-center p-1 mx-2 bg-[#002d59] /40  rounded-lg shadow-lg">
          {buttons.map((button, index) => {
            const isActive = location.pathname === button.ROUTE;
            const isLast = index === buttons.length - 1;

            return (
              <React.Fragment key={button.id}>
                <Link
                  to={button.ROUTE}
                  className={`
                    flex-1 flex items-center justify-center gap-1
                    py-2 px-1 rounded-md
                    text-xs font-medium
                    transition-all duration-200
                    ${
                      isActive
                        ? "bg-green-500 text-white shadow-md shadow-green-500/40"
                        : "text-white hover:text-white"
                    }
                  `}
                >
                  <button.icon className="text-sm" />
                  <span>{button.label}</span>
                </Link>
                {!isLast && (
                  <span className="text-white/30 text-xs mx-0.5">•</span>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {/* Desktop: Original 3-grid layout - visible on desktop */}
      <div className="hidden gap-2 p-2 md:grid md:grid-cols-3">
        {buttons.slice(0, 3).map((button) => (
          <Link
            to={button.ROUTE}
            key={button.id}
            className={`
              flex flex-col items-center justify-center 
              py-3 px-1 rounded-lg
              text-sm font-medium
              transition-opacity active:opacity-70
              ${
                isDarkMode
                  ? "bg-gray-800 text-gray-200"
                  : "bg-gray-100 text-gray-800"
              }
            `}
          >
            <button.icon className="mb-1 text-xl" />
            <span>{button.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RectangleGridButtons;
